import React, { useId } from 'react';

const studies = [
  { caption: 'From conversation to structure', type: 'Signal / Structure' },
  { caption: 'A different lens on performance', type: 'Observe / Compare' },
  { caption: 'More than one possible outcome', type: 'Explore / Reason' },
];

/** A local vector study; project selection reshapes the same continuous field. */
export function ResearchStudy({ selected }: { selected: number }) {
  const id = useId().replace(/:/g, '');
  return (
    <div className={`cx-study cx-study--${selected}`} aria-hidden="true">
      <div className="cx-study-top"><span>COGNIXIS / RESEARCH</span><span>0{selected + 1}</span></div>
      <svg className="cx-study-field" viewBox="0 0 520 390" fill="none">
        <defs>
          <linearGradient id={id} x1="65" y1="80" x2="460" y2="340" gradientUnits="userSpaceOnUse"><stop stopColor="#d3ed79" /><stop offset=".6" stopColor="#98a874" /><stop offset="1" stopColor="#38402d" /></linearGradient>
        </defs>
        <path d="M30 195H490M260 30V360" stroke="currentColor" strokeOpacity=".1" strokeDasharray="2 7" />
        <g className="cx-study-lines" stroke={`url(#${id})`}>
          {Array.from({ length: 26 }, (_, i) => {
            const t = i / 25;
            const y = 75 + t * 240;
            const left = 85 + t * 100;
            const right = 435 - t * 100;
            const radiusY = 150 - t * 95;
            const k = .5522848;
            const cornerA = [75 + t * 150, 65 + t * 50];
            const cornerB = [440 - t * 60, 110 + t * 150];
            const cornerC = [395 - t * 150, 325 - t * 50];
            const cornerD = [80 + t * 60, 280 - t * 150];
            const line = (from: number[], to: number[]) => `C${from.join(' ')} ${to.join(' ')} ${to.join(' ')}`;
            // Identical cubic topology lets CSS interpolate the studies as one field.
            const path = selected === 0
              ? `M45 ${y} C80 ${y - 55} 110 ${y - 30} 150 ${y} C190 ${y + 45} 220 ${350 - t * 310} 260 195 C300 ${40 + t * 310} 330 ${y - 45} 370 ${y} C410 ${y + 20} 450 ${y} 475 ${y}`
              : selected === 1
                ? `M${cornerA.join(' ')} ${line(cornerA, cornerB)} ${line(cornerB, cornerC)} ${line(cornerC, cornerD)} ${line(cornerD, cornerA)}`
                : `M${left} 195 C${left} ${195 - radiusY * k} ${260 - (260 - left) * k} ${195 - radiusY} 260 ${195 - radiusY} C${260 + (right - 260) * k} ${195 - radiusY} ${right} ${195 - radiusY * k} ${right} 195 C${right} ${195 + radiusY * k} ${260 + (right - 260) * k} ${195 + radiusY} 260 ${195 + radiusY} C${260 - (260 - left) * k} ${195 + radiusY} ${left} ${195 + radiusY * k} ${left} 195`;
            return <path key={i} d={path} opacity={.35 + Math.sin(t * Math.PI) * .65} strokeWidth=".9" />;
          })}
        </g>
        <circle className="cx-study-core" cx="260" cy="195" r="5" fill="#d3ed79" />
        <circle cx="260" cy="195" r="18" stroke="#d3ed79" strokeOpacity=".35" />
        <path d="M28 48V28H48M472 28H492V48M492 342V362H472M48 362H28V342" stroke="currentColor" strokeOpacity=".35" />
      </svg>
      <div className="cx-study-caption"><span>{studies[selected].type}</span><p key={selected}>{studies[selected].caption}</p></div>
    </div>
  );
}
